import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import TextArea from "@/common/components/TextArea";
import { Trash2Icon } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { NegotiationCounterValidationSchema } from "../../schemas/negotiationCounter.schema";
import { useState } from "react";

interface RejectProductModalProps {
  index: number;
  setIsCounterModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const RejectProductModal = ({ index, setIsCounterModalOpen }: RejectProductModalProps) => {
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  const { register, watch, trigger, setValue, resetField, formState: { errors } } = useFormContext<NegotiationCounterValidationSchema>();

  const watchProductDesiredAction = watch(`negotiation_products_attributes.${index}.desired_action`);

  const onCloseModal = () => {
    resetField(`negotiation_products_attributes.${index}.reject_observation`);
    setIsRejectModalOpen(false);
  };

  const onOpenModal = () => {
    setIsRejectModalOpen(true);
  };

  const onConfirm = async () => {
    const isValid = await trigger([`negotiation_products_attributes.${index}.reject_observation`]);

    if (isValid) {
      setValue(`negotiation_products_attributes.${index}.desired_action`, 'reject');

      resetField(`negotiation_products_attributes.${index}.counter_observation`);
      resetField(`negotiation_products_attributes.${index}.value`);

      setIsRejectModalOpen(false);
      setIsCounterModalOpen(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={isRejectModalOpen}
        setIsOpen={(newValue) => {
          if (newValue) onOpenModal();
          else onCloseModal();
        }}
        triggerDisabled={watchProductDesiredAction === 'reject'}
        Trigger={(
          <Button variant="error" className="text-white-800" disabled={watchProductDesiredAction === 'reject'}>
            {watchProductDesiredAction !== 'reject' ? 'Recusar produto' : 'Produto recusado'}

            <Trash2Icon strokeWidth={1.5} size={18} />
          </Button>
        )}
        title="Recusar produto"
        subtitle="Preencha o motivo para recusa da negociação deste produto"
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-white-400"
        body={(
          <div className="flex flex-col gap-4 text-white-800">
            <TextArea
              key={`reject-observation-${index}`}
              markAsRequired
              label="Justificativa"
              placeholder="Escreva sua justificativa"
              {...register(`negotiation_products_attributes.${index}.reject_observation`)}
              errorMessage={errors.negotiation_products_attributes?.[index]?.reject_observation?.message || undefined}
            />
          </div>
        )}
        useCancellableFooter
        cancelButtonText="Voltar"
        confirmButtonText="Confirmar"
        cancelButtonClassName="bg-white-200"
        className="rounded-lg overflow-hidden"
        onConfirm={onConfirm}
        onCancel={onCloseModal}
      />
    </>
  );
};

export default RejectProductModal;
